import React from 'react';
import { MonitorSelectType } from '@op/components/FilterCommon/types';
import { MonitorMethodConfigMap } from '../constants';
import MonitoringScopeItem from '../components';

export default function MonitorMethod(props: MonitorSelectType) {
  const { text, description, list } = MonitorMethodConfigMap[props.lang];

  return (
    <div className="dbo-monitoring-method">
      <div className="dbo-monitoring-scope-tips">
        <p>{text}</p>
        <p>{description}</p>
      </div>
      {list.map((item) => {
        return (
          <MonitoringScopeItem
            key={item.title}
            filterProps={props}
            {...item}
          ></MonitoringScopeItem>
        );
      })}
    </div>
  );
}
